/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export const DBaseState = {
	HOVERED: "HOVERED",
	ACTIVE: "ACTIVE",
	FOCUSED: "FOCUSED",
	UNFOCUSABLE: "UNFOCUSABLE",
	FOCUS_ROOT: "FOCUS_ROOT",
	FOCUS_REVERSE: "FOCUS_REVERSE",
	READ_ONLY: "READ_ONLY",
	DISABLED: "DISABLED",
	GESTURING: "GESTURING",
	PRESSED: "PRESSED",
	INVALID: "INVALID",
	PROCESSING: "PROCESSING",
	SUCCEEDED: "SUCCEEDED",
	FAILED: "FAILED",
	WARNED: "WARNED",
	CHANGED: "CHANGED",
	ALTERNATED: "ALTERNATED",
	NEW_WINDOW: "NEW_WINDOW"
};
